var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.params.value),function(value,name){return _c('span',{key:name},[_vm._v(" "+_vm._s(name)+": "+_vm._s(value)+" "+_vm._s("|")+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }